import { Client } from '../../data/models/client.model';

export function useIsClientOnboarding(client: Client | null): boolean {
  return client?.state === 'draft';
}
